export var BackupPostureControlSortField;
(function (BackupPostureControlSortField) {
    BackupPostureControlSortField["CONTROL_SORT_FIELD_NAME"] = "NAME";
    BackupPostureControlSortField["CONTROL_SORT_FIELD_SEVERITY"] = "SEVERITY";
})(BackupPostureControlSortField || (BackupPostureControlSortField = {}));
